export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';

export const updateUserRequest = ( updateData ) => ({
    type: UPDATE_USER_REQUEST,
    payload: { updateData }
});
